import React from 'react';
import { Link } from 'react-router-dom';
import { Languages, LogOut } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Mobile drawer opened by the hamburger. Contains the same links as the
 * desktop menu but stacked, plus language + auth buttons.
 */
const NavbarMobileMenu = ({ t, language, toggleLanguage, user, logout }) => (
  <div className="md:hidden bg-[#0a0e27] border-t border-white/5">
    <div className="px-4 py-6 space-y-4">
      <Link to="#features" className="block text-white/90 hover:text-white py-2">
        {t.nav.features}
      </Link>
      <Link to="#resources" className="block text-white/90 hover:text-white py-2">
        {t.nav.resources}
      </Link>
      <Link to="/docs" className="block text-white/90 hover:text-white py-2">
        {t.nav.library}
      </Link>
      <a href="/#pricing" className="block text-white/90 hover:text-white py-2">
        {t.nav.pricing}
      </a>

      <button
        onClick={toggleLanguage}
        className="flex items-center space-x-2 text-white/90 hover:text-white py-2 w-full"
      >
        <Languages size={18} />
        <span className="text-sm font-medium">{language === 'en' ? 'Ελληνικά' : 'English'}</span>
      </button>

      <div className="pt-4 space-y-2">
        {user && user.id ? (
          <Button
            data-testid="mobile-logout"
            onClick={logout}
            variant="ghost"
            className="w-full text-white/90 hover:text-white hover:bg-white/10"
          >
            <LogOut size={16} className="mr-2" />
            {language === 'el' ? 'Αποσύνδεση' : 'Logout'}
          </Button>
        ) : (
          <>
            <Button asChild variant="ghost" className="w-full text-white/90 hover:text-white hover:bg-white/10">
              <Link to="/login">{t.nav.login}</Link>
            </Button>
            <Button asChild className="w-full bg-white text-black hover:bg-white/90">
              <Link to="/register">{t.nav.signup}</Link>
            </Button>
          </>
        )}
      </div>
    </div>
  </div>
);

export default NavbarMobileMenu;
